<div class=" modal-header d-flex justify-content-center bg-light ">
    <h4 class="modal-title strong">Place Order</h4>
</div>
<div id="loader" *ngIf="enableLoader"></div>
<div *ngIf="!enableLoader">
<div class="modal-body bg-light">
    <form [formGroup]="consignForm" *ngIf="consignForm">

        <div class="center">
            <!-- <div class="small text-secondary  small">Material #</div> -->
            <h5 class="strong mb-2">{{consignForm.get('productName')?.value}}</h5>
            <div><span>Stock Available : </span>{{consignForm.get('stockAvailable')?.value}}</div>
            <div class="bold text-secondary mt-2">{{consignForm.get('location')?.value}}</div>
        </div>
        <div class="row g-3 mb-3 mt-4">
            <div class="col-md-6">
                <div class="bold">Base Price</div>
                 <div class="input-group">
                <div class="input-group-prepend">
                 <span class="input-group-text">$</span>
                 </div>
                <input type="text"  appCommondirective [beforeDecimal]="5" 
                [afterDecimal]="2" (keydown)="restrictInput($event)" formControlName="basePrice" class="form-control bold rounded-0">
              </div>
            </div>
            <div class="col-md-6">
                <div class="bold">Quantity(ST)</div>
                 <input type="text" formControlName="quantity"  [disabled]="consignForm?.get('stockAvailable')?.value===0 && popUp==='Place Order'" appCommondirective
                                [beforeDecimal]="5" [afterDecimal]="consignForm.get('allowedDecimalQty')?.value"
                                [numberType]="'positive'" 
                            id="quantityid"
                    class="form-control rounded-0">
                    <p class="text-danger small bold" *ngIf="(consignForm.get('quantity')?.dirty||consignForm.get('quantity')?.touched)&&(consignForm.get('quantity')?.value>consignForm.get('stockAvailable')?.value) && (popUp==='Place Order')">Quantity cannot
                        be greater than stock available
                    </p>
                    <div *ngIf="consignForm.get('quantity')?.invalid && consignForm.get('quantity')?.touched" class="text-danger bold mt-1">
                 Please Enter quantity
                </div>
            </div>
        </div>
        <hr>
         <div *ngIf="priceList?.length>0">
          <div formArrayName="priceList">
                <div class="row mb-3"  >
                <ng-container *ngFor="let price of 
                priceList.controls; let i=index">
                    <div class="col-md-6 mb-4" [formGroupName]="i" *ngIf=" price.get('kopCode')?.value!=='BASE'" >
                <div >
                       <label class="form-label bold" >{{price.get('kopName')?.value}}</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" >
                                    {{price.get('kopPriceSymbol')?.value}}</span>
                            </div>
                            <input class="form-control rounded-0" type="text"  appCommondirective
                                [beforeDecimal]="3" [afterDecimal]="2" [numberType]="'negative'" formControlName="kopPriceAmount">
                        </div>
                        </div>
                    </div>
                    </ng-container>
                </div>
            </div>

        </div> 
        <hr *ngIf="priceList?.length>0">
        <div class="row">
            <div class="col-md-6">
                <div class="bold">Order date*</div>
                <div class=" d-flex date-select">
                    <div class="input-group">
                        <input class="form-control border" placeholder="DD/MM/YYYY" name="deliveryDate" ngbDatepicker
                            #d="ngbDatepicker"  [minDate]="today" formControlName="deliveryDate" id="" required (click)="d.toggle()"
                            (dateSelect)="onDateSelection($event,'deliveryDate')" />
                    </div>
                    <i class="far pickup-calendar" (click)="d.toggle()"><img src="/images/calendar.svg" alt="customlogo"
                            width="18px" height="18px" class=""></i>
                </div >
                 <div *ngIf="consignForm.get('deliveryDate')?.invalid && consignForm.get('deliveryDate')?.touched" class="text-danger bold mt-1">
                 Please Enter Order date
                </div>
                <div *ngIf="isPastDeliveryDate" class="text-danger bold mt-1 text-nowrap">Order date should be today or future date</div>

            </div>
        </div>
           <div class="row g-3 mb-3 mt-4">
            <div class="col-md-6">
                <div class="bold">External reference no</div>
                 <div class="input-group">
                <input type="text" (keydown)="restrictInput($event)"   
                 formControlName="extRefNo" class="form-control bold rounded-0">
              </div>
            </div>
        </div>

        <!-- <div class="row d-flex mt-4">
            <div class="col-md-6">
                <div class="bold">Validity date*</div>
                <div class=" d-flex date-select">
                    <div class="input-group">
                        <input class="form-control border" placeholder="DD/MM/YYYY" name="" ngbDatepicker #s="ngbDatepicker"
                            formControlName="ValidityDate" [minDate]="today" id="" required (click)="s.toggle()"
                            (dateSelect)="onDateSelection($event,'ValidityDate')" />
                    </div>
                    <i class="far pickup-calendar" (click)="s.toggle()"><img src="/images/calendar.svg" alt="customlogo"
                            width="18px" height="18px" class=""></i>
                </div>
                  <div *ngIf="consignForm.get('ValidityDate')?.invalid && consignForm.get('ValidityDate')?.touched" class="text-danger bold mt-1">
                 Please Enter validity date
                </div>

            </div>
            <div class="col-md-6">
                <div class="bold">Validity time*</div>
            <div class="select-editable">
                            <select class="form-control" id="ValidityTime" formControlName="ValidityTime" (change)="onTimeSelection($event,'ValidityTime')" >
                                <option [value]="validityTime" *ngFor="let validityTime of timeArray">{{validityTime}}</option>
                            </select>
                        </div>
                 <div *ngIf="consignForm.get('ValidityTime')?.invalid && consignForm.get('ValidityTime')?.touched" class="text-danger bold mt-1">
                 Please Enter validity time
                </div>

            </div>


        </div> -->
        <!-- <div class="row d-flex mt-4">
            <div class="form-group col-md-12">
                <div for="Select1" class="semibold small mb-1">Timezone<span class="text-danger">*</span></div>
                <ng-select [dropdownPosition]="'bottom'" formControlName="Timezone" (change)="changeTimeZone($event)"
                    class=" mb-1 small semi-bold" bindLabel="description">
                    <ng-option *ngFor="let mod of master?.timeZones;let i = index"
                        [value]="mod.description">{{mod.description | titlecase}}</ng-option>
                </ng-select>
            </div>
        </div> -->

    </form>
</div>
<div class="modal-footer ">
    <div class="col-md-12 col-sm-12">
        <button class="btn btn-block btn-lg  btn-primary" type="submit" [disabled]="consignForm.invalid" (click)="next()">Next</button>
        <button class="btn btn-block btn-light btn-lg" type="submit" (click)="closeModal()">Close</button>
    </div>
</div>
</div>